"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    integration: 'Integration' || 'integration',
    createIntegration: 'Skapa integration' || 'createIntegration',
    activate: 'Aktivera' || 'activate',
    deactivate: 'Inaktivera' || 'deactivate',
    sendTechnicalEmail: 'E-posta teknisk information' || 'sendTechnicalEmail',
    setUpExternalFortnoxConnection: 'Aktivera Fortnox-integration' || 'setUpExternalFortnoxConnection',
    updateFortnoxIntegration: 'Uppdatera fortnox integration' || 'updateFortnoxIntegration',
    ensureRecycleArticlesInExternalFortnox: 'Aktivera pant på order' || 'ensureRecycleArticlesInExternalFortnox',
    setUpInternalFortnoxConnection: 'Aktivera Fortnox-integration' || 'setUpInternalFortnoxConnection',
    setUpExtendConnection: 'Skapa/uppdatera integration mot Extend' || 'setUpExtendConnection',
    updateExtendConnection: 'Uppdatera integration mot Extend' || 'updateExtendConnection',
    setUpWhgroupConnection: 'Skapa/uppdatera integration mot WH Group' || 'setUpWhgroupConnection',
    updateWhgroupConnection: 'Uppdatera integration mot WH Group' || 'updateWhgroupConnection',
    resetIntegrationRun: 'Återställ integrationskörning' || 'resetIntegrationRun',
    startIntegrationRun: 'Starta integrationskörning' || 'startIntegrationRun',
    stopIntegrationRun: 'Stoppa integrationskörning' || 'stopIntegrationRun',
    triggerScheduledRun: 'Starta schemalagd körning' || 'triggerScheduledRun',
    writeIncoming: 'Spara' || 'writeIncoming',
    writeOutgoing: 'Spara' || 'writeOutgoing',
    writeGetEndpoint: 'Spara' || 'writeGetEndpoint',
    writeScheduledRun: 'Spara' || 'writeScheduledRun',
    deleteIntegrationRun: 'Spara' || 'deleteIntegrationRun',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    name: 'Namn' || 'name',
    incomingAuthorization: 'Inkommande autentisering' || 'incomingAuthorization',
    incomingAuthorizations: {
        Bearer: 'Bearer-autentisering' || 'Bearer',
        None: 'Ingen' || 'None',
        SHA256MAC: 'SHA256-signatur' || 'SHA256MAC',
    },
    incomingAccessToken: 'Inkommande accesstoken' || 'incomingAccessToken',
    outgoingAuthorization: 'Utgående autentisering' || 'outgoingAuthorization',
    outgoingAuthorizations: {
        Bearer: 'Bearer-autentisering' || 'Bearer',
        None: 'Ingen' || 'None',
        Basic: 'Basic-autentisering' || 'Basic',
    },
    apiKey: 'API-nyckel' || 'apiKey',
    endpoint: 'Ändpunkt' || 'endpoint',
    incomingEndpoint: 'Inkommande API-ändpunkt' || 'incomingEndpoint',
    organizationId: 'Organizationsid' || 'organizationId',
    s3StorageFolder: 'S3-lagringsmapp' || 's3StorageFolder',
    active: 'Aktiverad' || 'active',
    type: 'Typ av integration' || 'type',
    types: {
        EDI: 'EDI' || 'EDI',
        FORTNOX: 'FORTNOX' || 'FORTNOX',
        WHGROUP: 'WHGROUP' || 'WHGROUP',
        EXTEND: 'EXTEND' || 'EXTEND',
        OTHER: 'ANNAT' || 'OTHER',
    },
    status: 'Tillstånd' || 'status',
    statuses: {
        waiting: 'Kö' || 'waiting',
        'files received': 'Tagit emot filer' || 'files received',
        development: 'Utveckling' || 'development',
        test: 'Test' || 'test',
        production: 'Produktion' || 'production',
    },
    comment: 'Kommentar' || 'comment',
    systemNameOfIntegratingPartner: 'Namn på system med vilket vi integrerar' ||
        'systemNameOfIntegratingPartner',
    technicalContactName: 'Teknisk kontaktperson' || 'technicalContactName',
    technicalContactEmail: 'E-post till teknisk kontakt' || 'technicalContactEmail',
    technicalContactPhone: 'Telefon till teknisk kontakt' || 'technicalContactPhone',
    commericalContactName: 'Kundkontaktperson' || 'commericalContactName',
    commericalContactEmail: 'E-post till kundkontakt' || 'commericalContactEmail',
    commericalContactPhone: 'Telefon till kundkontakt' || 'commericalContactPhone',
    supportEmail: 'E-post som ska ta emot fel för integrationen' || 'supportEmail',
    settings: 'Inställningar' || 'settings',
    ftpHost: 'FTP-server' || 'ftpHost',
    ftpPort: 'FTP-port' || 'ftpPort',
    ftpWriteDir: 'FTP-skrivkatalog' || 'ftpWriteDir',
    ftpReadDir: 'FTP-läskatalog' || 'ftpReadDir',
    ftpUsername: 'FTP-användare' || 'ftpUsername',
    ftpPassword: 'FTP-lösenord' || 'ftpPassword',
    ftpPasswordAtFlaivy: 'FTP-lösenord' || 'ftpPasswordAtFlaivy',
    ftpDevPasswordAtFlaivy: 'FTP-lösenord - Utveckling (sftp-dev.flaivy.com)' ||
        'ftpDevPasswordAtFlaivy',
    description: 'Beskrivning' || 'description',
    getEndpoints: {
        id: 'Identitet' || 'id',
        name: 'Namn' || 'name',
        active: 'Aktiverad' || 'active',
        entityName: 'Entitetsnamn' || 'entityName',
        entityNames: {
            article: 'Artikel' || 'article',
            order: 'Order' || 'order',
            supplier: 'Leverantör' || 'supplier',
            supplierCustomer: 'Leverantörskund' || 'supplierCustomer',
            purchaseOrder: 'Inleverans' || 'purchaseOrder',
            invoice: 'Faktura' || 'invoice',
            priceList: 'Prislista' || 'priceList',
            settlement: 'Avräkning' || 'settlement',
            customerSubUnit: 'Central kund' || 'customerSubUnit',
        },
        mapping: 'Mappning' || 'mapping',
    },
    incomings: {
        id: 'Identitet' || 'id',
        name: 'Namn' || 'name',
        entityName: 'Entitetsnamn' || 'entityName',
        entityNames: {
            article: 'Artikel' || 'article',
            order: 'Order' || 'order',
            supplier: 'Leverantör' || 'supplier',
            supplierCustomer: 'Leverantörskund' || 'supplierCustomer',
            purchaseOrder: 'Inleverans' || 'purchaseOrder',
            invoice: 'Faktura' || 'invoice',
            priceList: 'Prislista' || 'priceList',
            settlement: 'Avräkning' || 'settlement',
            customerSubUnit: 'Central kund' || 'customerSubUnit',
        },
        active: 'Aktiverad' || 'active',
        incomingChannel: 'Kanal' || 'incomingChannel',
        incomingChannels: {
            'FTP-file': 'FTP-fil' || 'FTP-file',
            'HTTP-POST': 'HTTP-POST' || 'HTTP-POST',
            FORTNOX: 'Fortnox' || 'FORTNOX',
            CRONJOB: 'Cron jobb' || 'CRONJOB',
            INTERNALCALL: 'Anropas internt' || 'INTERNALCALL',
        },
        filter: 'Filter' || 'filter',
        reader: 'Läsformat' || 'reader',
        readers: {
            NOOP: 'NOOP' || 'NOOP',
            XML: 'XML' || 'XML',
            JSON: 'JSON' || 'JSON',
            EDIFACTD96APRICAT: 'EDIFACTD96APRICAT' || 'EDIFACTD96APRICAT',
            EDIFACTD96AORDERS: 'EDIFACTD96AORDERS' || 'EDIFACTD96AORDERS',
            D96AORDERRSP: 'D96AORDERRSP' || 'D96AORDERRSP',
            CSV: 'CSV' || 'CSV',
            PYRAMIDPRICEREADER: 'PYRAMIDPRICEREADER' || 'PYRAMIDPRICEREADER',
            FRESHXMLREADER: 'FRESHXMLREADER' || 'FRESHXMLREADER',
            FRESHCSVARTICLEREADER: 'FRESHCSVARTICLEREADER' || 'FRESHCSVARTICLEREADER',
            FXORDER: 'FXORDER' || 'FXORDER',
            FXORDERFEEDBACK: 'FXORDERFEEDBACK' || 'FXORDERFEEDBACK',
            FXCUSTOMER: 'FXCUSTOMER' || 'FXCUSTOMER',
            FXARTICLESANDPRICES: 'FXARTICLESANDPRICES' || 'FXARTICLESANDPRICES',
            WHGROUPSTOCKQUANTITIES: 'WHGROUPSTOCKQUANTITIES' || 'WHGROUPSTOCKQUANTITIES',
            WHGROUPPRICES: 'WHGROUPPRICES' || 'WHGROUPPRICES',
            WHGROUPARTICLES: 'WHGROUPARTICLES' || 'WHGROUPARTICLES',
            WHGROUPCUSTOMERS: 'WHGROUPCUSTOMERS' || 'WHGROUPCUSTOMERS',
            BRIGHTCOMCUSTOMER: 'BRIGHTCOMCUSTOMER' || 'BRIGHTCOMCUSTOMER',
            BRIGHTCOMSTOCKQUANTITY: 'BRIGHTCOMSTOCKQUANTITY' || 'BRIGHTCOMSTOCKQUANTITY',
            BRIGHTCOMPRICELISTENTRY: 'BRIGHTCOMPRICELISTENTRY' || 'BRIGHTCOMPRICELISTENTRY',
            BRIGHTCOMPRICELISTS: 'BRIGHTCOMPRICELISTS' || 'BRIGHTCOMPRICELISTS',
            BRIGHTCOMORDER: 'BRIGHTCOMORDER' || 'BRIGHTCOMORDER',
            BRIGHTCOMARTICLE: 'BRIGHTCOMARTICLE' || 'BRIGHTCOMARTICLE',
            EXTENDWEBHOOK: 'EXTENDWEBHOOK' || 'EXTENDWEBHOOK',
            EXTENDORDER: 'EXTENDORDER' || 'EXTENDORDER',
            EXTENDSTOCKQUANTITY: 'EXTENDSTOCKQUANTITY' || 'EXTENDSTOCKQUANTITY',
            EXTENDPURCHASEORDER: 'EXTENDPURCHASEORDER' || 'EXTENDPURCHASEORDER',
            EXTENDRETURNORDER: 'EXTENDRETURNORDER' || 'EXTENDRETURNORDER',
            EXTENDINVOICE: 'Extend fakturor' || 'EXTENDINVOICE',
            EXTENDCUSTOMER: 'EXTENDCUSTOMER' || 'EXTENDCUSTOMER',
            GOLDENEDIARTICLE: 'GOLDENEDIARTICLE' || 'GOLDENEDIARTICLE',
            HICOREARTICLE: 'HiCore artiklar' || 'HICOREARTICLE',
            HICORECUSTOMER: 'HiCore kunder' || 'HICORECUSTOMER',
            HICORECUSTOMERORDER: 'HiCore order' || 'HICORECUSTOMERORDER',
            HICOREPRICES: 'HiCore priser' || 'HICOREPRICES',
            HICORESTOCK: 'HiCore lagersaldo' || 'HICORESTOCK',
        },
        mapping: 'Mappning' || 'mapping',
    },
    outgoings: {
        id: 'Identitet' || 'id',
        name: 'Namn' || 'name',
        entityName: 'Entitetsnamn' || 'entityName',
        entityNames: {
            article: 'Artikel' || 'article',
            order: 'Order' || 'order',
            supplier: 'Leverantör' || 'supplier',
            supplierCustomer: 'Leverantörskund' || 'supplierCustomer',
            purchaseOrder: 'Inleverans' || 'purchaseOrder',
            invoice: 'Faktura' || 'invoice',
            priceList: 'Prislista' || 'priceList',
            settlement: 'Avräkning' || 'settlement',
            customerSubUnit: 'Central kund' || 'customerSubUnit',
        },
        active: 'Aktiverad' || 'active',
        triggeredByEvent: 'Vilken händelse triggar?' || 'triggeredByEvent',
        triggeredByEvents: {
            ORDER_PLACED: 'ORDER_PLACED' || 'ORDER_PLACED',
            ORDER_APPROVED: 'ORDER_APPROVED' || 'ORDER_APPROVED',
            ORDER_UPDATED: 'ORDER_UPDATED' || 'ORDER_UPDATED',
            ORDER_CANCELLED: 'ORDER_CANCELLED' || 'ORDER_CANCELLED',
            ORDER_CONNECTED_TO_SUPPLIER_CUSTOMER: 'ORDER_CONNECTED_TO_SUPPLIER_CUSTOMER' ||
                'ORDER_CONNECTED_TO_SUPPLIER_CUSTOMER',
            'ORDER_*': 'ORDER_*' || 'ORDER_*',
            PURCHASE_ORDER_REQUESTED: 'PURCHASE_ORDER_REQUESTED' || 'PURCHASE_ORDER_REQUESTED',
            PURCHASE_ORDER_SENT_TO_SUPPLIER: 'PURCHASE_ORDER_SENT_TO_SUPPLIER' || 'PURCHASE_ORDER_SENT_TO_SUPPLIER',
            'SUPPLIER_CUSTOMER_*': 'SUPPLIER_CUSTOMER_*' || 'SUPPLIER_CUSTOMER_*',
            CUSTOMER_SUB_UNIT_UPDATED: 'CUSTOMER_SUB_UNIT_UPDATED' || 'CUSTOMER_SUB_UNIT_UPDATED',
            SUPPLIER_CUSTOMER_CREATED: 'SUPPLIER_CUSTOMER_CREATED' || 'SUPPLIER_CUSTOMER_CREATED',
            'ARTICLE_*': 'ARTICLE_*' || 'ARTICLE_*',
            ARTICLE_UPDATED: 'ARTICLE_UPDATED' || 'ARTICLE_UPDATED',
            'SUPPLIER_*': 'SUPPLIER_*' || 'SUPPLIER_*',
            SUPPLIER_SALES_REPORT_SENT_TO_SUPPLIER: 'SUPPLIER_SALES_REPORT_SENT_TO_SUPPLIER' ||
                'SUPPLIER_SALES_REPORT_SENT_TO_SUPPLIER',
            SETTLEMENT_SENT_TO_SUPPLIER_ORGANIZATION: 'SETTLEMENT_SENT_TO_SUPPLIER_ORGANIZATION' ||
                'SETTLEMENT_SENT_TO_SUPPLIER_ORGANIZATION',
        },
        filter: 'Filter: vad i eventet ska trigga?' || 'filter',
        writer: 'Skrivformat' || 'writer',
        writers: {
            EDIFACTD96AORDERS: 'Edifact - D96AORDERS' || 'EDIFACTD96AORDERS',
            PEPPOLBISORDERING32: 'PEPPOL - BIS Ordering 3.2' || 'PEPPOLBISORDERING32',
            TEMPLATE: 'Mall' || 'TEMPLATE',
            PYRAMIDORDER: 'PYRAMID - Order' || 'PYRAMIDORDER',
            NOOP: 'NOOP' || 'NOOP',
            EVENT: 'EVENT' || 'EVENT',
            FXORDER: 'FXORDER' || 'FXORDER',
            FXARTICLE: 'FXARTICLE' || 'FXARTICLE',
            FXCUSTOMER: 'FXCUSTOMER' || 'FXCUSTOMER',
            BRIGHTCOMORDER: 'BRIGHTCOMORDER' || 'BRIGHTCOMORDER',
            BRIGHTCOMCUSTOMER: 'BRIGHTCOMCUSTOMER' || 'BRIGHTCOMCUSTOMER',
            BRIGHTCOMARTICLE: 'BRIGHTCOMARTICLE' || 'BRIGHTCOMARTICLE',
            EXTENDARTICLE: 'EXTENDARTICLE' || 'EXTENDARTICLE',
            EXTENDARTICLEFROMPURCHASEORDER: 'EXTENDARTICLEFROMPURCHASEORDER' || 'EXTENDARTICLEFROMPURCHASEORDER',
            EXTENDORDER: 'EXTENDORDER' || 'EXTENDORDER',
            EXTENDPURCHASEORDER: 'EXTENDPURCHASEORDER' || 'EXTENDPURCHASEORDER',
            EXTENDCUSTOMER: 'EXTENDCUSTOMER' || 'EXTENDCUSTOMER',
            EXTENDCUSTOMERFROMORDER: 'EXTENDCUSTOMERFROMORDER' || 'EXTENDCUSTOMERFROMORDER',
            HICORECUSTOMERORDER: 'HiCore order' || 'HICORECUSTOMERORDER',
            HICORECUSTOMER: 'HiCore kunder' || 'HICORECUSTOMER',
        },
        options: 'Tillägg' || 'options',
        outputTemplate: 'Skrivmall' || 'outputTemplate',
        outputFileNameTemplate: 'Mall för filnamn' || 'outputFileNameTemplate',
        outgoingChannel: 'Kanal' || 'outgoingChannel',
        outgoingChannels: {
            'v1.outgoingMessage.writeFtpFile': 'v1.outgoingMessage.writeFtpFile' || 'v1.outgoingMessage.writeFtpFile',
            'v1.outgoingMessage.writeSftpFile': 'v1.outgoingMessage.writeSftpFile' ||
                'v1.outgoingMessage.writeSftpFile',
            'v1.email.sendEmail': 'v1.email.sendEmail' || 'v1.email.sendEmail',
            'v1.fortnox-external.sendOrder': 'v1.fortnox-external.sendOrder' || 'v1.fortnox-external.sendOrder',
            'v1.fortnox-external.cancelOrder': 'v1.fortnox-external.cancelOrder' || 'v1.fortnox-external.cancelOrder',
            'v1.fortnox-external.sendCustomer': 'v1.fortnox-external.sendCustomer' ||
                'v1.fortnox-external.sendCustomer',
            'v1.fortnox-external.sendArticle': 'v1.fortnox-external.sendArticle' || 'v1.fortnox-external.sendArticle',
            'v1.fortnox-external.sendSupplier': 'v1.fortnox-external.sendSupplier' ||
                'v1.fortnox-external.sendSupplier',
            'v1.fortnox-external.sendSupplierSalesReport': 'v1.fortnox-external.sendSupplierSalesReport' ||
                'v1.fortnox-external.sendSupplierSalesReport',
            'v1.fortnox-external.sendSettlement': 'v1.fortnox-external.sendSettlement' ||
                'v1.fortnox-external.sendSettlement',
            'v1.brightcom.sendOrder': 'v1.brightcom.sendOrder' || 'v1.brightcom.sendOrder',
            'v1.brightcom.sendCustomer': 'v1.brightcom.sendCustomer' || 'v1.brightcom.sendCustomer',
            'v1.brightcom.sendArticle': 'v1.brightcom.sendArticle' || 'v1.brightcom.sendArticle',
            'v1.golden-edi.sendArticle': 'v1.golden-edi.sendArticle' || 'v1.golden-edi.sendArticle',
            'v1.whgroup.sendOrder': 'v1.whgroup.sendOrder' || 'v1.whgroup.sendOrder',
            'v1.whgroup.sendCustomer': 'v1.whgroup.sendCustomer' || 'v1.whgroup.sendCustomer',
            'v1.extend.createArticle': 'v1.extend.createArticle' || 'v1.extend.createArticle',
            'v1.extend.updateArticle': 'v1.extend.updateArticle' || 'v1.extend.updateArticle',
            'v1.extend.sendOrder': 'v1.extend.sendOrder' || 'v1.extend.sendOrder',
            'v1.extend.sendPurchaseOrder': 'v1.extend.sendPurchaseOrder' || 'v1.extend.sendPurchaseOrder',
            'v1.extend.sendCustomer': 'v1.extend.sendCustomer' || 'v1.extend.sendCustomer',
            'v1.extend.updateCustomer': 'v1.extend.updateCustomer' || 'v1.extend.updateCustomer',
            'v1.article.handlePublications': 'v1.article.handlePublications' || 'v1.article.handlePublications',
            'v1.hicore.sendCustomer': 'v1.hicore.sendCustomer' || 'v1.hicore.sendCustomer',
            'v1.hicore.sendOrder': 'v1.hicore.sendOrder' || 'v1.hicore.sendOrder',
        },
    },
    scheduledRuns: {
        id: 'Identitet' || 'id',
        name: 'Namn' || 'name',
        active: 'Aktiverad' || 'active',
        schedule: 'Schema' || 'schedule',
        jobName: 'Jobbnamn' || 'jobName',
        jobNames: {
            'hi-core-import': 'HiCore import' || 'hi-core-import',
            'extend-import-return-orders': 'Synka retur ordrar från exakta' || 'extend-import-return-orders',
            'extend-import-customer-orders': 'Synka order från exakta' || 'extend-import-customer-orders',
            'extend-import-customer-invoices': 'Synka fakturor från exakta' || 'extend-import-customer-invoices',
            'handle-incoming-files': 'Hantera inkommande filer' || 'handle-incoming-files',
            'privab-import-articles': 'Läs in privabs excel fil för artiklar' || 'privab-import-articles',
            'wh-group-import-stock-quantities': 'Wh group importera lagersaldon' || 'wh-group-import-stock-quantities',
            'wh-group-import-articles-customers': 'Wh group importera artiklar och kunder' ||
                'wh-group-import-articles-customers',
            'sync-external-fortnox-for-integration': 'Synka data med Fortnox' || 'sync-external-fortnox-for-integration',
            'sync-external-fortnox-price-lists-for-integration': 'Synka prislistor med Fortnox' ||
                'sync-external-fortnox-price-lists-for-integration',
        },
    },
    integrationRuns: {
        id: 'Identitet' || 'id',
        jobName: 'Jobbnamn' || 'jobName',
        status: 'Status' || 'status',
        statuses: {
            Error: 'Fel' || 'Error',
            Success: 'OK' || 'Success',
            Started: 'Kör just nu' || 'Started',
            Undetermined: 'Något har hänt, kommer försöka igen' || 'Undetermined',
        },
        log: 'Meddelande' || 'log',
        error: 'Teknisk information om fel' || 'error',
        start: 'Startad' || 'start',
        end: 'Avslutad' || 'end',
    },
};
